export default __webpack_public_path__ + "static/media/krwawobrody_theme.b9dd6df2.mp3";